import { useTranslation } from "react-i18next";
import { IMAGE_STATUS } from '../../../common/constants';

interface LoadingOverlayProps {
  isSplitView: boolean;
  currentImageStatus: string;
  retryCurrentImage: () => void;
  comparedCurrentImageStatus: string;
  comparedRetryCurrentImage: (() => void) | null;
}

const LoadingOverlay = ({
  isSplitView,
  currentImageStatus,
  retryCurrentImage,
  comparedCurrentImageStatus,
  comparedRetryCurrentImage,
}: LoadingOverlayProps) => {
  const { t } = useTranslation();

  if (currentImageStatus === IMAGE_STATUS.LOADING || (isSplitView && comparedCurrentImageStatus === IMAGE_STATUS.LOADING)) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-30">
        <div className="text-center text-white">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p>{t("doc_viewer.loading_panorama")}</p>
        </div>
      </div>
    );
  }

  if (currentImageStatus === IMAGE_STATUS.ERROR || (isSplitView && comparedCurrentImageStatus === IMAGE_STATUS.ERROR)) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-30">
        <div className="text-center text-white">
          <p>{t("doc_viewer.loading_panorama_error")}</p>
          <button
            className="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
            onClick={() => {
              if (currentImageStatus === IMAGE_STATUS.ERROR) {
                retryCurrentImage();
              }
              if (comparedCurrentImageStatus === IMAGE_STATUS.ERROR) {
                comparedRetryCurrentImage?.();
              }
            }}
          >
            {t("doc_viewer.try_again")}
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default LoadingOverlay;
